import { Box, Grid } from '@mui/material';
import React, { FC } from 'react';
import StyledBox from 'views/rebranded-module/deals-module/DealDetailsViewV2/components/DealTitleSection/DealTitleSection.styles';
import { Share, BreadcrumbsV2, Typography700 } from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import PATHS from 'lib/navigation/paths';
interface DealTitleSectionProps {
  dealTitle?: string;
}

const DealTitleSection:FC<DealTitleSectionProps> = (props) => {
  const { dealTitle } = props;
  const content = useContent('');
  const breadcrumbsObject = {
    links: [
      {
        text: content.DealDetailsPage.erLabel,
        path: PATHS.home(),
      },
      {
        text: content.DealDetailsPage.exclusiveOfferLabel,
        path: PATHS.motorcycleDeals.index(),
      },
      {
        text: dealTitle,
      },
    ],
  };
  return (
    <StyledBox>
      <BreadcrumbsV2 data={breadcrumbsObject} />
      <Grid container  alignItems="center" className="DTSTitleContainer">
        <Grid item xl={7.75} lg={7} md={8} sm={9.5}>
          <Typography700 variant="h6" component="h1">
            {dealTitle}
          </Typography700>
        </Grid>
        <Grid item xl={4.25} lg={5} md={4} sm={2.5}>
          <Box display="flex" justifyContent="flex-end">
            <Share
              journeyName={dealTitle}
              shareModalTitle={content.DealDetailsPage.shareModalTitle}
            />
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export { DealTitleSection };